require('../../modules/es.object.assign');
var path = require('../../internals/path');

module.exports = path.Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/assign.js
// module id = 441
// module chunks = 0